import { DARK, IMAGE_OVERLAY_Z_INDEX } from "../core/constants";

import Box from "./Box";
import CloseButton from "./CloseButton";
import PropTypes from "prop-types";
import React, { useRef, useEffect } from "react";
import { useAppContext } from "./AppContext";
import ProductSpin from "./ProductSpin";
import FullSizeProductImage from "./FullSizeProductImage";

function ProductImagesFullScreen({ images, productSpinImages, brandImages }) {
  const productSpinRef = useRef();
  const { productImageOverlayOpen, setProductImageOverlayOpen, clickedImage } =
    useAppContext();

  useEffect(() => {
    if (
      productSpinRef.current &&
      productImageOverlayOpen &&
      clickedImage === "productSpin"
    ) {
      productSpinRef.current.scrollIntoView();
    }
  }, [clickedImage]);

  return (
    <Box
      position="fixed"
      top={0}
      left={0}
      bg="white"
      height="100vh"
      width="100vw"
      zIndex={IMAGE_OVERLAY_Z_INDEX}
      transition="opacity 200ms"
      opacity={productImageOverlayOpen ? 1 : 0}
      pointerEvents={productImageOverlayOpen ? "all" : "none"}
      overflowY="auto"
    >
      <Box
        position="fixed"
        top={40}
        right={[15, "4.76vw", null, null]}
        transition="opacity 200ms"
        hover="opacity: 0.5"
      >
        <CloseButton
          theme={DARK}
          onClick={() => setProductImageOverlayOpen(false)}
        />
      </Box>
      <Box width="85%" mx="auto" my={50}>
        {images.map((image) => {
          return (
            <FullSizeProductImage key={image.url} image={image} pb="100%" />
          );
        })}
        {productSpinImages.length > 0 && (
          <Box ref={productSpinRef}>
            <ProductSpin images={productSpinImages} />
          </Box>
        )}
        {typeof brandImages !== "undefined" && brandImages.length > 0 && (
          <Box mt={20}>
            {brandImages.map((image) => {
              return (
                <FullSizeProductImage
                  key={image.url}
                  image={image}
                  pb={`${(image.height / image.width) * 100}%`}
                />
              );
            })}
          </Box>
        )}
      </Box>
    </Box>
  );
}

export default ProductImagesFullScreen;

ProductImagesFullScreen.propTypes = {
  images: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    })
  ).isRequired,
  brandImages: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      width: PropTypes.string.isRequired,
      height: PropTypes.string.isRequired,
    })
  ).isRequired,
};
